const DEFAULT_CLOSE_TIME = 5000;

export { DEFAULT_CLOSE_TIME as D };
